export const boolStringToBool = (value) => {
  const isString = typeof value === 'string';
  const isTrue = value === 'true';

  return isString ? isTrue : value;
};

export const numStringToNum = (value) => {
  const isString = typeof value === 'string';
  const newVal = parseFloat(value);

  return isString ? newVal : value;
};

export default boolStringToBool;
